export default "__VITE_ASSET__rbAm94i1__"